import Cookies from "js-cookie";
import { COOKIE_PREFIX, COOKIE_DOMAIN } from "../constants";

const getCookieNameWithPrefix = (name) =>
  COOKIE_PREFIX ? `${COOKIE_PREFIX}-${name}` : name;

const get = (name) => Cookies.get(getCookieNameWithPrefix(name));

const set = (name, value, config) =>
  Cookies.set(getCookieNameWithPrefix(name), value, {
    domain: COOKIE_DOMAIN,
    ...config,
  });

const remove = (name, config) =>
  Cookies.remove(getCookieNameWithPrefix(name), {
    domain: COOKIE_DOMAIN,
    ...config,
  });

const Cookie = {
  get,
  set,
  remove,
};

export default Cookie;
